"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatasetPartnerIndexingTask = void 0;
const routes_1 = require("../../routes");
const getDatasetPartnerIndexingTask = (client) => async (options) => {
    const { indexName, partnerId, productId } = options;
    const queryParams = new URLSearchParams();
    if (indexName) {
        queryParams.append('index_name', indexName);
    }
    if (productId) {
        queryParams.append('product_id', productId);
    }
    const url = `${routes_1.ENDPOINTS.GET_DATASET_PARTNER_INDEXING_TASK.applyParams(partnerId)}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    const { data } = await client.get(url);
    return data;
};
exports.getDatasetPartnerIndexingTask = getDatasetPartnerIndexingTask;
